<template>
  <div class="childtrackingsystem-analyse">
    <div
      v-if="isLoading"
      class="row bg-white"
    >
      <div class="col-12 text-center">
        <img
          src="../../assets/img/loading.gif"
          alt="Loading"
          style="width: 80px; height: 80px;"
        >
      </div>
    </div>
    <div v-if="!isAnalyse && !isContent">
      <div class="row bg-white pt-3">
        <div class="col-md-4">
          <label
            for="mentor"
            class="form-label"
          >Mentor</label>
          <input
            type="search"
            class="form-select form-select-sm"
            id="mentor"
            placeholder="Zoek..."
            name="mentor"
            list="mentors-list"
            v-model="searchedMentor"
            @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
            @change="searchResults()"
          />
          <datalist id="mentors-list">
            <option
              value="Alle"
              selected
            ></option>
            <option
              v-for="mentor in mentors"
              :value="mentor.name"
              :key="mentor.id"
            >
            </option>
          </datalist>
        </div>
        <div class="col-md-4">
          <label
            for="age"
            class="form-label"
          >Leeftijd</label>
          <input
            type="search"
            class="form-select form-select-sm"
            id="age"
            placeholder="Zoek..."
            name="age"
            list="ages-list"
            v-model="searchedAge"
            @focus="searchedAge = ''; document.getElementById('ages-list').style.display='block';"
            @change="searchResults()"
          />
          <datalist id="ages-list">
            <option
              value="Alle"
              selected
            ></option>
            <option
              v-for="age in ages"
              :value="age.description"
              :key="age.id"
            >
            </option>
          </datalist>
        </div>
        <div class="col-md-4">
          <label
            for="filterChildren"
            class="form-label"
          >Filter kinderen</label>
          <select
            class="form-select form-select-sm"
            id="filterChildren"
            name="filterChildren"
            v-model="filterChildren"
            @change="getResults()"
          >
            <option value="all">Alle</option>
            <option value="present">Aanwezig</option>
            <option value="vve">VVE</option>
          </select>
        </div>
      </div>
      <div class="row bg-white pt-1 pb-3">
        <div class="col-md-4">
          <label
            for="filterChildren"
            class="form-label"
          >Ontwikkelingsgebied</label>
          <input
            type="search"
            class="form-select form-select-sm"
            id="idCategory"
            placeholder="Zoek..."
            name="idCategory"
            list="categories-list"
            v-model="searchedCategory"
            @focus="searchedCategory = ''; document.getElementById('categories-list').style.display='block';"
            @change="searchResults()"
          />
          <datalist id="categories-list">
            <option
              value="Alle"
              selected
            ></option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.name"
            >
            </option>
          </datalist>
        </div>
        <div class="col-md-4">
          <label
            for="idQuestion"
            class="form-label"
          >Doelen</label>
          <input
            type="search"
            class="form-select form-select-sm"
            id="idQuestion"
            placeholder="Zoek..."
            name="idQuestion"
            list="questions-list"
            v-model="searchedQuestion"
            @focus="searchedQuestion = ''; document.getElementById('questions-list').style.display='block';"
            @change="searchResults()"
          />
          <datalist id="questions-list">
            <option
              value="Alle"
              selected
            ></option>
            <option
              v-for="question in questions"
              :key="question.id"
              :value="question.vraag"
            >
            </option>
          </datalist>
        </div>
      </div>
      <div class="row bg-white pt-3">
        <div class="col-md-6">
          <div class="input-fields">
            <div class="form-fields-wrapper">
              <span class="input-fields-global-title">Kinderen</span>
              <div class="input-fields-global-stripe"></div>
              <div class="row input-fields-row">
                <div
                  class="col"
                  style="overflow:auto;"
                >
                  <ul class="list-group">
                    <li
                      v-for="child in filteredRows"
                      :key="child.id"
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <input
                          v-model="checkedChildren"
                          type="checkbox"
                          name="children"
                          :value="child.id"
                          @input="reloadObservationLists($event, child.age)"
                        >{{ child.full_name }} ({{ child.birthday }})
                      </div>
                      <small>
                <span
                  v-if="child.alertCTS"
                  @click="viewAnalyse(child.idResult);"
                >
                  <icon
                    name="look-into"
                    :fontSize="'1rem'"
                  ></icon>
                </span>
                        {{ child.age }} mnd
                      </small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <br><br>
        </div>
        <div class="col-md-6">
          <div class="input-fields">
            <div class="form-fields-wrapper">
              <span class="input-fields-global-title">Observatielijsten</span>
              <div class="input-fields-global-stripe"></div>
              <div class="row input-fields-row">
                <div class="col ms-3">
                  <input
                    type="checkbox"
                    name="loadAllLists"
                    value="loadAllLists"
                    @change="loadAllLists($event)"
                  /> Laad alle observatielijsten
                </div>
              </div>
              <div class="row input-fields-row">
                <div class="col">
                  <ul class="list-group">
                    <li
                      v-for="(list, index) in results"
                      :key="index"
                      class="list-group-item"
                    >
                      <input
                        v-model="checkedList"
                        type="radio"
                        name="observationList"
                        :value="list.id"
                      >{{ list.titel }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row input-fields-row">
                <div class="col text-end">
                  <button
                    class="btn btn-outline-primary"
                    @click="analyseChildren()"
                  >
                    Observeren
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isAnalyse">
      <childtrackingsystem-analysechild
        :checked-children="checkedChildren"
        :checked-list="checkedList"
        :checked-category="selectedCategory"
        :checked-question="selectedQuestion"
      />
    </div>
    <div
      v-if="isContent"
      class="row bg-white"
    >
      <div class="col-md-12">
        <childtrackingsystem-editchildobservationlist
          :idResult="idResult"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ChildtrackingsystemAnalysechild from "./AnalyseChild";
import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
import Icon from "@/components/Icon";

export default {
  name: 'ChildtrackingsystemAnalyse',
  components: {
    ChildtrackingsystemEditchildobservationlist,
    ChildtrackingsystemAnalysechild,
    Icon
  },
  data() {
    return {
      isLoading: false,
      isAnalyse: false,
      results: [],
      ages: [],
      selectedAge: 0,
      searchedAge: 'Alle',
      mentors: [],
      childrenCTS: [],
      searchedMentor: 'Alle',
      selectedMentor: 0,
      checkedList: 0,
      checkedChildren: [],
      analysedChildren: [],
      selectedCategory: 0,
      searchedCategory: 'Alle',
      categories: [],
      selAge: [],
      selectedQuestion: 0,
      searchedQuestion: 'Alle',
      questions: [],
      isContent: false,
      idResult: 0,
      idList: 0,
      idCategory: 0,
      idChild: 0,
      filterChildren: 'all'
    };
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    },
    filteredRows() {
      return this.$store.getters.globalChildByTextFilter ? this.childrenCTS.filter(child => child.full_name.toLowerCase().includes(this.$store.getters.globalChildByTextFilter.toLowerCase())) : this.childrenCTS;
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    };
    this.getResults();
  },
  methods: {
    loadAllLists(event) {
      let childAge = false;
      if (!event.target.checked) {
        childAge = this.selAge.join(',');
      }
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/observationLists', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedAge: false,
        selectedMentor: this.selectedMentor,
        selectedCategory: this.selectedCategory,
        selAgeChild: childAge,
        ipad: true
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response) {
          this.results = response.observationLists;
        }
      });
    },
    reloadObservationLists(event, childAge) {
      if (event.target.checked) {
        this.selAge.push(childAge);
      } else {
        let index = this.selAge.indexOf(childAge);
        if (index > -1) {
          this.selAge.splice(index, 1);
        }
      }
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/observationLists', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedAge: this.selectedAge,
        selectedMentor: this.selectedMentor,
        selectedCategory: this.selectedCategory,
        selAgeChild: this.selAge.join(','),
        ipad: true
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response) {
          this.results = response.observationLists;
        }
      });
    },
    getResults() {
      this.isLoading = true;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/analyse', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idChild: this.$store.getters.selectedChild,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedAge: this.selectedAge,
        idMentor: this.selectedMentor,
        idCategory: this.selectedCategory,
        idQuestion: this.selectedQuestion,
        ipad: true,
        selectedFilterChildren: this.filterChildren
      }).then((response) => {
        this.isLoading = false;
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response) {
          this.results = response.lists;
          this.ages = response.ages;
          this.mentors = response.mentors;
          this.childrenCTS = response.children;
          this.categories = response.categories;
        }
      });
    },
    getQuestions() {
      this.isLoading = true;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      // eslint-disable-next-line no-undef
      this.$request.post('/ChildTrackingSystem/getQuestions', {
        idCategory: this.selectedCategory,
        selectedAge: this.selectedAge,
        ipad: true
      }).then((response) => {
        this.isLoading = false;
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response) {
          this.questions = response.questions;
        }
      });
    },
    analyseChildren() {
      if (this.checkedChildren.length === 0) {
        alert('Kies de kind(eren) die u wilt observeren!');
      } else if (this.checkedList === 0) {
        alert('Kies een observatielijst!');
      } else {
        this.$store.commit('REGISTER_ACTIVE_REQUEST');
        // eslint-disable-next-line no-undef
        this.$request.post('/ChildTrackingSystem/getAnalysedChildren', {
          checkedChildren: this.checkedChildren,
          checkedList: this.checkedList
        }).then((response) => {
          this.isLoading = false;
          this.$store.commit('REMOVE_ACTIVE_REQUEST');
          if (response.analysedChildren.length > 0) {
            if (confirm(response.analysedChildren)) {
              if (response.checkedChildren.length > 0) {
                this.checkedChildren = response.checkedChildren;
                this.isAnalyse = true;
              }
            }
          } else {
            this.isAnalyse = true;
          }
        });
      }
    },
    viewAnalyse(idResult) {
      this.idResult = idResult;
      this.isContent = true;
    },
    searchResults() {
      if (this.searchedMentor === 'Alle') {
        this.selectedMentor = 0;
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id;
          }
        });
      }
      if (this.searchedAge === 'Alle') {
        this.selectedAge = 0;
      } else {
        this.ages.forEach(age => {
          if (age.description.toLowerCase().includes(this.searchedAge.toLowerCase())) {
            this.selectedAge = age.id;
          }
        });
      }
      if (this.searchedCategory === 'Alle') {
        this.selectedCategory = 0;
        this.getQuestions();
      } else {
        this.categories.forEach(category => {
          if (category.name.toLowerCase().includes(this.searchedCategory.toLowerCase())) {
            this.selectedCategory = category.id;
            this.getQuestions();
          }
        });
      }
      if (this.searchedQuestion === 'Alle') {
        this.selectedQuestion = 0;
      } else {
        this.questions.forEach(question => {
          if (question.vraag.toLowerCase().includes(this.searchedQuestion.toLowerCase())) {
            this.selectedQuestion = question.id;
          }
        });
      }
      document.activeElement.blur();
      this.getResults();
    }
  }
};
</script>
<style scoped>
.table th {
  color: #445161;
  background-color: #dedee7;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}

input[type=checkbox] {
  transform: scale(1.5, 1.5);
  margin-right: 15px;
}

input[type=radio] {
  transform: scale(1.5, 1.5);
  margin-right: 15px;
}

.input-fields-buttons {
  margin-top: 10px;
  margin-bottom: 10px;
}

.input-fields-buttons input {
  margin-left: 8px;
  float: right;
}

.input-fields-global-title {
  padding: 4px 4px 4px 0;
  font-size: 14px;
  float: left;
  color: rgb(122.61, 131.32, 150.08);
  text-transform: uppercase;
  letter-spacing: 0.25px;
  margin: 8px 0 4px;
}

.input-fields-global-stripe {
  height: 1px;
  background-color: rgb(76.08, 143.28, 197.04);
  float: none;
  overflow: hidden;
  position: relative;
  top: 22px;
  margin-right: 4px;
}

.input-fields-row {
  clear: both;
  padding-top: 10px;
}

.input-fields-item {
  clear: both;
  padding: 10px 0;
  margin: 0;
  width: 100%;
}

.input-fields-item.row {
  padding: 12px 0;
}

.input-fields-item-title {
  font-size: 11.5px;
  color: rgb(60.39, 64.68, 73.92);
}

.input-fields-item:first-child {
  padding-top: 0;
}

.input-fields-item.with-border-bottom {
  border-bottom: 1px solid rgb(194.52, 205.44, 228.96);
}

.input-fields-item.with-border-bottom:last-child {
  border-bottom: none;
}

.input-fields .form-fields-wrapper {
  margin-bottom: 18px;
}

.input-fields.horizontal .row.input-fields-item {
  margin: 0;
}

.input-fields.horizontal .row.input-fields-item .input-fields-item-title {
  font-size: 12px;
  margin-top: 5px;
}

.input-fields.horizontal .row.input-fields-item:first-child {
  margin: 24px 0 0;
}

.input-fields .row-devider {
  margin: 12px 0;
  display: block;
  height: 32px;
}

.input-fields .input-changed {
  background-color: rgb(255, 224.5, 166);
}

</style>